import { TwoFactorAuthenticationService } from '@api'
import { z } from 'zod'

const qrCodeResponseSchema = z.string()
const backupCodesResponseSchema = z.array(z.string())

async function generateQRCode() {
  const data = await TwoFactorAuthenticationService.generateQrCodeImageUri()

  return qrCodeResponseSchema.parse(data)
}

async function enableTfa(code: string) {
  await TwoFactorAuthenticationService.enableTfa({ requestBody: { code } })
}

async function disableTfa(code: string) {
  await TwoFactorAuthenticationService.disableTfa({ requestBody: { code } })
}

async function generateRecoveryCodes() {
  const data = await TwoFactorAuthenticationService.generateRecoveryCodes()

  return backupCodesResponseSchema.parse(data)
}

export const tfaService = {
  generateQRCode,
  enableTfa,
  disableTfa,
  generateRecoveryCodes,
}
